import { Button } from '@mui/material'
import { useCreate, useGetIdentity, useNotify, useRedirect, useTranslate } from 'react-admin'
import { AddDraftCommand } from '../../GeneratedClients/FreeBillApi'
import { useFormContext, useFormState } from "react-hook-form";

const CreateDraftButton = () => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const translate = useTranslate()
  const { getValues } = useFormContext()
  const { isValid } = useFormState()
  const [create] = useCreate()
  const notify = useNotify()
  const redirect = useRedirect()
  if(identityLoading) return null

  const handleSave = () => {
    if(isValid) {
      const data: AddDraftCommand = getValues()
      data.userId = identity?.id.toString()
      create('drafts', {data}, {
        onSuccess: (res) => { 
          notify(translate('resources.drafts.notifications.created')) 
          redirect('show', 'drafts', res.id)
        },
        onError: (error) => { notify(`${error}`, {type: 'error'}) }
      })  
    }
  }

  return (
    <Button 
      onClick={handleSave} 
      variant={'contained'} 
      size='small'
      type='submit'
    >
      {translate('resources.drafts.actions.create')}
    </Button>
  )
}

export default CreateDraftButton